import React from 'react';
import { Row, Col, Input, Button, Divider } from 'antd';

import './style.css';



export default class WorkReportTemplate extends React.Component {

	changeTableItemValue(fatherIndex, index, childIndex, event) {
		let copyCurrent = [...this.props.currentData];
		copyCurrent[fatherIndex].values[index][childIndex] = event.target.value;
		this.props.editReportContent(copyCurrent);
	}
	changeTablecolumnValue(fatherIndex, index, event) {
		let copyCurrent = [...this.props.currentData];
		copyCurrent[fatherIndex].columns[index] = event.target.value;
		this.props.editReportContent(copyCurrent);
	}
	changeRowItemValue(fatherIndex, index, event) {
		let copyCurrent = [...this.props.currentData];
		copyCurrent[fatherIndex].values[index] = event.target.value;
		this.props.editReportContent(copyCurrent);
	}
	changeRowsItemValue(fatherIndex, index, childIndex, event) {
		let copyCurrent = [...this.props.currentData];
		copyCurrent[fatherIndex].values[index][childIndex] = event.target.value;
		this.props.editReportContent(copyCurrent);
	}
	changeColumnItemValue(fatherIndex, index, event) {
		let copyCurrent = [...this.props.currentData];
		copyCurrent[fatherIndex].children[index].value = event.target.value;
		this.props.editReportContent(copyCurrent);
	}
	changeColumnsItemValue(fatherIndex, index, event) {
		let copyCurrent = [...this.props.currentData];
		copyCurrent[fatherIndex].children[index].value = event.target.value;
		this.props.editReportContent(copyCurrent);
	}

	render() {
		return (
			<div className={this.props.openDetail ? "disable-daily-report" : ""} style={{ border: "0px solid #cccccc", borderRadius: "3px", textAlign: "left" }}>
				{this.props.currentData && this.props.currentData instanceof Array &&
					this.props.currentData.map((item, tableIndex) => {
						switch (item.type) {
							case "table":
								return (<div key={tableIndex}>
									<Row style={{ backgroundColor: "#f0f0f0", minHeight: "40px", lineHeight: "40px", display: 'flex', flexWrap: 'wrap' }}>
										{item.headers.map((header, headerIndex) => {
											if (0 === headerIndex) {
												return (<Col key={headerIndex} style={{ border: "1px solid #cccccc", minHeight: "40px", lineHeight: "40px", textAlign: "center", width: ((header.width / 24.0)) * 100 + "%" }}>{header.title}</Col>)
											}
											else {
												return (<Col key={headerIndex} style={{ border: "1px solid #cccccc", minHeight: "40px", lineHeight: "40px", textAlign: "center" }} span={header.width}>{header.title}</Col>)
											}
										})}
									</Row>
									{item.columns.map((column, columnIndex) => {
										return (<Row key={columnIndex} style={{ display: 'flex', flexWrap: 'wrap' }}>
											{item.headers.map((header, headerChildIndex) => {
												if (0 === headerChildIndex) {
													return <Col key={headerChildIndex}
														style={{ border: "1px solid #cccccc", backgroundColor: "#f0f0f0", textAlign: "center", lineHeight: "40px", width: ((header.width / 24.0)) * 100 + "%" }}>{column}</Col>
												} else {
													return (
														<Col key={headerChildIndex} span={header.width}
															className="report-textarea"
															style={{ border: "1px solid #cccccc", lineHeight: "40px", padding: "0px 0px", textAlign: this.props.iscenter ? "center" : "left" }}>
															<Input.TextArea style={{ verticalAlign: "middle", padding: "0px 0px", border: "0", borderBottom: "1px solid #cccccc", textAlign: this.props.iscenter ? "center" : "left" }}
																disabled={this.props.openDetail} autosize={{ minRows: 1.5, maxRows: 999 }} value={item.values[columnIndex][headerChildIndex - 1]}
																onChange={this.changeTableItemValue.bind(this, tableIndex, columnIndex, headerChildIndex - 1)} />
														</Col>)
												}
											})}</Row>)
									})}
									<div style={{ height: "10px", border: "0" }}></div>
								</div>)
							case "table_education":
								return (<div key={tableIndex}>

									<Row style={{ backgroundColor: "#f0f0f0", minHeight: "40px", lineHeight: "40px", display: 'flex', flexWrap: 'wrap' }}>
										{item.headers.map((header, headerIndex) => {
											return (<Col key={headerIndex} style={{ border: "1px solid #cccccc", minHeight: "40px", lineHeight: "40px", textAlign: "center" }} span={header.width}>{header.title}</Col>)
										})}
									</Row>
									{item.columns.map((column, columnIndex) => {
										return (<Row key={columnIndex} style={{ display: 'flex', flexWrap: 'wrap' }}>
											{item.headers.map((header, headerChildIndex) => {
												if (0 === headerChildIndex) {
													if (0 === columnIndex) {
														return <Col key={headerChildIndex} span={header.width}
															className="report-textarea"
															style={{ border: "1px solid #cccccc", backgroundColor: "#f0f0f0", textAlign: "center", lineHeight: "40px" }}>
															<Input.TextArea style={{ verticalAlign: "middle", padding: "0px 0px", border: "0", borderBottom: "1px solid #cccccc", textAlign: "center" }}
																disabled={this.props.openDetail} autosize={{ minRows: 1.5, maxRows: 999 }} value={column}
																onChange={this.changeTablecolumnValue.bind(this, tableIndex, columnIndex)} /></Col>
													} else {
														return <Col key={headerChildIndex} span={header.width}
															style={{ border: "1px solid #cccccc", backgroundColor: "#f0f0f0", textAlign: "center", lineHeight: "40px" }} ></Col>
													}

												}	 else {
													return (
														<Col key={headerChildIndex} span={header.width}
															className="report-textarea"
															style={{ border: "1px solid #cccccc", lineHeight: "40px", padding: "0px 0px", textAlign: "center" }}>
															<Input.TextArea style={{ verticalAlign: "middle", padding: "0px 0px", border: "0", borderBottom: "1px solid #cccccc", textAlign: "center" }}
																disabled={this.props.openDetail} autosize={{ minRows: 1.5, maxRows: 999 }} value={item.values[columnIndex][headerChildIndex - 1]}
																onChange={this.changeTableItemValue.bind(this, tableIndex, columnIndex, headerChildIndex - 1)} />
														</Col>)
												}
											})}</Row>)
									})}
									<div style={{ textAlign: "right", margin: "10px 0" }}>
										{/* <Button type="primary" onClick={this.props.AddEducationRow}>
											<span>新增外教(行)</span>
										</Button> */}
										{/* <Divider type="vertical" />
										<Button type="primary" onClick={this.props.AddEducationTable}>
											<span>新增</span>
										</Button> */}
									</div>
									<div style={{ height: "10px", border: "0" }}></div>
								</div>)
							case "row":
								return (<div key={tableIndex}>
									<div style={{ backgroundColor: "#1a1a1a", minHeight: "30px", lineHeight: "30px", border: "1px solid #cccccc", padding: "0px 35px" }}>
										<span style={{ color: "#ffffff", fontSize: "17px" }}>{item.title}</span>
									</div>
									{item.values.map((value, valueIndex) => {
										return (<div key={valueIndex}
											style={{ minHeight: "30px", lineHeight: "30px", border: "1px solid #cccccc", padding: "5px 15px" }}>
											<Input.TextArea disabled={this.props.openDetail} value={value} rows={5} autosize={{ minRows: 2, maxRows: 999 }}
												onChange={this.changeRowItemValue.bind(this, tableIndex, valueIndex)} />
										</div>)
									})}
									<div style={{ height: "10px", border: "0" }}></div>
								</div>
								)
							case "rows":
								return (<div key={tableIndex}>
									<Row style={{ backgroundColor: "#f0f0f0", lineHeight: "40px", padding: "0px 0px" }}>
										{item.headers.map((header, headerIndex) => {
											return (<Col key={headerIndex} style={{ border: "1px solid #cccccc", textAlign: "center" }} span={header.width}>{header.title}</Col>)
										})}
									</Row>
									{item.values.map((value, valueIndex) => {
										return (<Row key={valueIndex} style={{ lineHeight: "40px", display: 'flex', flexWrap: 'wrap' }}>
											{value.map((singleValue, singleValueIndex) => {
												return (<Col key={singleValueIndex} span={item.headers[singleValueIndex].width}
													className="report-textarea"
													style={{ border: "1px solid #cccccc", padding: "0px 0px", textAlign: this.props.iscenter ? "center" : "left" }}>
													<Input.TextArea disabled={this.props.openDetail} autosize={{ minRows: 1.5, maxRows: 999 }} value={singleValue}
														onChange={this.changeRowsItemValue.bind(this, tableIndex, valueIndex, singleValueIndex)} style={{ border: "0", textAlign: this.props.iscenter ? "center" : "left" }} />
												</Col>)
											})}
										</Row>)
									})}
									{
										!this.props.isforeign && <div style={{ height: "10px", border: "0" }}></div>
									}

								</div>)
							case "column":
								return (<div key={tableIndex}>
									<Row>
										<Col span={4}>
											<div style={{ backgroundColor: "#f0f0f0", height: item.height, lineHeight: item.height, border: "1px solid #cccccc", padding: "0px 35px" }}>
												{item.title}
											</div>
										</Col>
										<Col span={20}>
											<Row>
												{item.children.map((child, childIndex) => {
													return (<Col key={childIndex} span={6}>
														<div style={{ backgroundColor: "#f0f0f0", height: "30px", lineHeight: "30px", border: "1px solid #cccccc", padding: "0px 5px" }}>{child.title}</div>
														<div style={{ height: "30px", lineHeight: "30px", border: "1px solid #cccccc", padding: "0px 15px" }}>
															<Input disabled={this.props.openDetail} value={child.value} style={{ width: "100%" }}
																onChange={this.changeColumnItemValue.bind(this, tableIndex, childIndex)} />
														</div>
													</Col>)
												})}
											</Row>
										</Col>
									</Row>
									<div style={{ height: "10px", border: "0" }}></div>
								</div>)
							case "columns":
								return (<div key={tableIndex}>
									<Row>
										<Col span={4}>
											<div style={{ backgroundColor: "#f0f0f0", height: item.height, lineHeight: item.height, border: "1px solid #cccccc", padding: "0px 35px" }}>
												{item.title}
											</div>
										</Col>
										<Col span={20}>
											{item.children.map((child, childIndex) => {
												return (<Row key={childIndex}>
													<Col span={6} style={{ height: "30px", lineHeight: "30px", border: "1px solid #cccccc", backgroundColor: "#f0f0f0" }}>{child.title}</Col>
													<Col span={18} style={{ height: "30px", lineHeight: "30px", border: "1px solid #cccccc", padding: "0px 15px" }}>
														<Input disabled={this.props.openDetail} style={{ width: "100%" }} value={child.value}
															onChange={this.changeColumnsItemValue.bind(this, tableIndex, childIndex)} />
													</Col>
												</Row>)
											})}
										</Col>
									</Row>
									<div style={{ height: "10px", border: "0" }}></div>
								</div>)
							case "title":
								return (<div key={tableIndex}>
									<Row style={{ backgroundColor: "#111111", color: "#fcfcfc", minHeight: "30px", lineHeight: "30px", border: "1px solid #cccccc", padding: "0px 35px" }}>
										<span style={{ color: "#ffffff", fontSize: "17px" }}>{item.title}</span>
									</Row>
								</div>)
							default:
								return false;
						}
					})}
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/routes/WorkReport/WorkReportTemplate.js